export default {
    status_no: '403',
    name: 'Forbidden',
    message: 'Access to this recourse on the server is denied',
}
